var _rect, _path, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnEasysub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2017 20.6902L8.90569 10.3217C8.75679 9.13046 10.0544 8.29793 11.0752 8.92981L20.3055 14.6438C21.4267 15.3379 21.0891 17.0508 19.7884 17.2676L15.5742 17.97C15.1847 18.0349 14.8395 18.2581 14.6204 18.5867L12.8079 21.3054C12.0737 22.4068 10.3659 22.0036 10.2017 20.6902Z",
    fill: "#262949"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.24093,
    y1: 6.11229,
    x2: 8.72343,
    y2: 3.15726,
    stroke: "#EA7E68",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.3352,
    y1: 7.6,
    x2: 15.1352,
    y2: 5.2,
    stroke: "#EA7E68",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 4,
    y2: -1,
    transform: "matrix(-0.813657 -0.581346 -0.581346 0.813657 6.06836 10.4531)",
    stroke: "#EA7E68",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEasysub);
export default __webpack_public_path__ + "static/media/icn-easysub.8aad80bd10383c0417cf16d98d8194bb.svg";
export { ForwardRef as ReactComponent };